import { useContext, useEffect } from "react";

import { NoteContext } from "../../../model/contexts/note.context";

import "./NoteModalForm.scss";

const NoteModalForm = ({
  isVisible,
  onClose,
  note,
  setNote,
  resetNoteForm,
  noteErrorMessage,
  setNoteErrorMessage,
  dateConverted,
}) => {
  const selectProjectID = localStorage.getItem("selectProjectID");
  const selectTaskID = localStorage.getItem("selectTaskID");
  const selectTaskName = localStorage.getItem("selectTaskName");

  const {
    notes,
    notesLoading,
    notesError,
    fetchAllNotesFromTask,
    saveNote,
    deleteNote,
  } = useContext(NoteContext);

  useEffect(() => {
    const loadNotes = async () => {
      if (!isVisible) return;
      if (!selectProjectID || !selectTaskID) return;

      await fetchAllNotesFromTask(selectProjectID, selectTaskID);
    };

    loadNotes();
  }, [isVisible, selectProjectID, selectTaskID]);

  if (!isVisible) return null;

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setNote((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleNoteFormSubmit = async (event) => {
    event.preventDefault();

    const trimmedDescription = note.description?.trim() || "";

    if (!trimmedDescription) {
      setNoteErrorMessage("The note cannot be empty!");
      return;
    }

    const notePayload = {
      ...(note?.id ? { id: note.id } : {}),
      description: trimmedDescription,
      taskID: selectTaskID,
      projectID: selectProjectID,
    };

    const success = await saveNote(notePayload);

    if (!success) {
      setNoteErrorMessage("Failed to save note");
      return;
    }

    setNoteErrorMessage("");
    resetNoteForm();
  };

  const handleDeleteNote = async (noteItem) => {
    const selectNoteID = noteItem.id;

    const success = await deleteNote(selectNoteID);

    if (!success) {
      setNoteErrorMessage("Failed to delete note");
    }
  };

  return (
    <div className="note-modal-overlay" onClick={onClose}>
      <div className="note-side-modal" onClick={(e) => e.stopPropagation()}>
        <button className="cancel-button" onClick={onClose}>
          X
        </button>

        <h3>Task Notes For:</h3>
        <label>{selectTaskName}</label>

        <form className="note-modal-form" onSubmit={handleNoteFormSubmit}>
          <div className="notes-list">
            {notesLoading ? (
              <div className="no-notes-wrapper">
                <label className="no-notes-label">Loading Notes...</label>
              </div>
            ) : notes.length === 0 ? (
              <div className="no-notes-wrapper">
                <label className="no-notes-label">No Notes Yet</label>
              </div>
            ) : (
              notes.map((noteItem) => (
                <div key={noteItem.id} className="note-item">
                  <div className="note-description">{noteItem.description}</div>

                  <div>
                    <div className="note-date">
                      {dateConverted(noteItem.dateModified)}
                    </div>

                    <div
                      className="note-delete-button"
                      onClick={() => handleDeleteNote(noteItem)}
                    >
                      Delete
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>

          {(noteErrorMessage || notesError) && (
            <p style={{ color: "red" }}>{noteErrorMessage || notesError}</p>
          )}

          <textarea
            name="description"
            value={note.description}
            onChange={handleInputChange}
            placeholder="Enter a new note..."
            className="note-input"
          />

          <button type="submit" className="add-note-button">
            Add Note
          </button>
        </form>
      </div>
    </div>
  );
};

export default NoteModalForm;
